import { IconLoader } from '@ui/src';
import { CardTypes } from './types';

import cn from './card.module.css';

const Card = ({
  children,
  title,
  isLoading,
  className,
  transparent,
  zIndex,
  titleContent,
}: CardTypes) => {
  let content;

  if (isLoading) {
    content = (
      <div className={cn.loaderWrapper}>
        <IconLoader />
      </div>
    );
  } else {
    content = children;
  }

  return (
    <>
      {title && <div className={cn.cardTitle}>{title}</div>}
      {titleContent}
      <div
        className={`${cn.card} ${className || ''} ${
          transparent ? cn.transparent : ''
        }`}
        style={{ zIndex }}
      >
        {content}
      </div>
    </>
  );
};

export default Card;
